import { translateFr as tfr } from "@/i18n";
// ISO country list (FR labels) for searchable selectors
export const COUNTRIES = [
  { code: "FR", label: "France" },
  { code: "BE", label: "Belgique" },
  { code: "CH", label: "Suisse" },
  { code: "LU", label: "Luxembourg" },
  { code: "MC", label: "Monaco" },
  { code: "DE", label: "Allemagne" },
  { code: "ES", label: "Espagne" },
  { code: "IT", label: "Italie" },
  { code: "PT", label: "Portugal" },
  { code: "GB", label: "Royaume-Uni" },
  { code: "IE", label: "Irlande" },
  { code: "NL", label: "Pays-Bas" },
  { code: "AT", label: "Autriche" },
  { code: "DK", label: "Danemark" },
  { code: "SE", label: tfr("Suède") },
  { code: "NO", label: tfr("Norvège") },
  { code: "FI", label: "Finlande" },
  { code: "PL", label: "Pologne" },
  { code: "CZ", label: tfr("Tchéquie") },
  { code: "SK", label: "Slovaquie" },
  { code: "HU", label: "Hongrie" },
  { code: "RO", label: "Roumanie" },
  { code: "BG", label: "Bulgarie" },
  { code: "GR", label: tfr("Grèce") },
  { code: "HR", label: "Croatie" },
  { code: "RS", label: "Serbie" },
  { code: "SI", label: tfr("Slovénie") },
  { code: "TR", label: "Turquie" },
  { code: "UA", label: "Ukraine" },
  { code: "US", label: tfr("États-Unis") },
  { code: "CA", label: "Canada" },
  { code: "MX", label: "Mexique" },
  { code: "BR", label: tfr("Brésil") },
  { code: "AR", label: "Argentine" },
  { code: "CL", label: "Chili" },
  { code: "CO", label: "Colombie" },
  { code: "UY", label: "Uruguay" },
  { code: "MA", label: "Maroc" },
  { code: "DZ", label: tfr("Algérie") },
  { code: "TN", label: "Tunisie" },
  { code: "SN", label: tfr("Sénégal") },
  { code: "CI", label: tfr("Côte d'Ivoire") },
  { code: "CM", label: "Cameroun" },
  { code: "NG", label: "Nigeria" },
  { code: "GH", label: "Ghana" },
  { code: "ZA", label: "Afrique du Sud" },
  { code: "EG", label: tfr("Égypte") },
  { code: "QA", label: "Qatar" },
  { code: "AE", label: tfr("Émirats arabes unis") },
  { code: "SA", label: "Arabie saoudite" },
  { code: "JP", label: "Japon" },
  { code: "KR", label: tfr("Corée du Sud") },
  { code: "CN", label: "Chine" },
  { code: "IN", label: "Inde" },
  { code: "AU", label: "Australie" },
  { code: "NZ", label: tfr("Nouvelle-Zélande") },
];

export function countryLabel(code) {
  return COUNTRIES.find((c) => c.code === code)?.label || code;
}
